<template>
  <div>
    <vue-headful title="ID/paspoort en VOG Certificaat" />
    <Header page_title="ID/paspoort en VOG Certificaat" />
    <div class="app-body container-fluid">
      <form
        method="post"
        enctype="multipart/form-data"
        @change="onFormChange"
        @submit.prevent="onSubmit"
      >
        <button type="submit" ref="submit" hidden>submit</button>
        <div class="bg-gray upload-photo step block" hidden>
          <div class="px-4 mx-2 py-4">
            <div class="text-center pt-4 mb-1 position-relative">
              <span v-if="!user.avatar" class="photo-comment">
                Upload
                <br />profielfoto
              </span>
              <img
                v-if="!user.avatar"
                alt="arrow"
                src="../../assets/arrow.png"
                class="arrow"
              />
              <div class="pb-3">
                <div
                  v-if="user.avatar && !preview_avatar"
                  class="avatar profile position-relative d-block mx-auto overflow-hidden rounded-circle"
                >
                  <input
                    type="file"
                    ref="avatar"
                    @change="onFileChangeAvatar"
                    class="placeholder"
                  />
                  <div
                    class="image_background"
                    :style="this.ImageBackground(user.avatar)"
                  ></div>
                </div>
                <div
                  v-if="preview_avatar"
                  class="avatar profile position-relative d-block mx-auto overflow-hidden rounded-circle"
                >
                  <input
                    type="file"
                    ref="avatar"
                    @change="onFileChangeAvatar"
                    class="placeholder"
                  />
                  <div
                    class="image_background"
                    :style="this.ImageBackground(preview_avatar)"
                  ></div>
                </div>
                <div
                  v-if="!user.avatar && !preview_avatar"
                  class="icon svg d-block mx-auto position-relative"
                >
                  <input
                    type="file"
                    ref="avatar"
                    @change="onFileChangeAvatar"
                    class="placeholder"
                  />
                </div>
              </div>
              <p class="mb-0">
                <strong>{{ user.firstname }}</strong>
              </p>
              <p class="mb-0">{{ user.email }}</p>
            </div>
          </div>
        </div>
        <div v-if="this.$store.state.notification.notifications.length > 0">
          <NotificationContainer />
        </div>
        <div class="upload-passport step block">
          <div class="">
            <div class="">
              <h2 class="sd-title mini mb-2">
                Maak of upload een foto van je ID, paspoort of verblijfsdocument.
              </h2>
              <p class="sd-text regular" v-if="elContains([0, 3], user.is_keesing)">Selecteer hieronder welke verificatie je wilt gebruiken:</p>
              <div class="mb-1 pb-1 sd-custom verification" v-if="elContains([0, 3], user.is_keesing)">
                <div class="custom-radio custom-control-inline">
                  <input
                    type="radio"
                    id="id_type_P"
                    name="id_type"
                    class="custom-control-input"
                    v-model="form.id_type"
                    v-bind:value="'P'"
                    @click="toggleUpload"
                    checked
                  />
                  <label class="custom-control-label" for="id_type_P">Paspoort </label>
                </div>
                <div class="custom-radio custom-control-inline">
                  <input
                    type="radio"
                    id="id_type_I"
                    name="id_type"
                    class="custom-control-input"
                    v-model="form.id_type"
                    v-bind:value="'I'"
                    @click="toggleUpload"
                  />
                  <label class="custom-control-label" for="id_type_I">ID </label>
                </div>
                <div class="custom-radio custom-control-inline">
                  <input
                    type="radio"
                    id="id_type_V"
                    name="id_type"
                    class="custom-control-input"
                    v-model="form.id_type"
                    v-bind:value="'V'"
                    @click="toggleUpload"
                  />
                  <label class="custom-control-label" for="id_type_V">Verblijfsdocument </label>
                </div>
              </div>
              <div class="document mb-4 photo_id" :class="[elContains([1, 2, 9], user.is_keesing) ? 'id-approved' : '']">
                <a v-if="!modalConfirmed" @click="openModal">
                  <svg-icon icon="id_card" />
                  <div v-if="elContains([0, 3], user.is_keesing)" class="text-container">
                    <svg-icon icon="warning" class="missing" />
                    Foto <b>voorzijde</b> uploaden
                  </div>
                  <div v-if="elContains([1, 2, 9], user.is_keesing)" class="text-container">
                    <svg-icon icon="checkmark_circle" class="check" />
                    Foto <b>voorzijde</b> geüpload
                  </div>
                </a>
                <label for="image_front" v-else>
                  <input
                    v-if="elContains([0, 3], user.is_keesing)"
                    type="file"
                    ref="image_front"
                    @change="onFileChangeImage"
                    accept="image/x-png, image/jpeg"
                    class="placeholder"
                    id="image_front"
                  />
                  <svg-icon icon="id_card" />
                  <div v-if="elContains([0, 3], user.is_keesing) && (!this.$refs || !this.$refs.image_front || !this.$refs.image_front.files[0])" class="text-container">
                    <svg-icon icon="warning" class="missing" />
                    Foto <b>voorzijde</b> uploaden
                  </div>
                  <div v-if="elContains([1, 2, 9], user.is_keesing) || (this.$refs && this.$refs.image_front && this.$refs.image_front.files[0])" class="text-container">
                    <svg-icon icon="checkmark_circle" class="check" />
                    Foto <b>voorzijde</b> geüpload
                  </div>
                </label>
              </div>
              <div class="document mb-4 photo_id" :class="[elContains([1, 2, 9], user.is_keesing) ? 'id-approved' : '']">
                <a v-if="!modalConfirmed" @click="openModal">
                  <svg-icon icon="id_card_back" />
                  <div v-if="elContains([0, 3], user.is_keesing)" class="text-container">
                    <svg-icon icon="warning" class="missing"/>
                    Foto <b>achterzijde</b> uploaden
                  </div>
                  <div v-if="elContains([1, 2, 9], user.is_keesing)" class="text-container">
                    <svg-icon icon="checkmark_circle" class="check"/>
                    Foto <b>achterzijde</b> geüpload
                  </div>
                </a>
                <label for="image_back" v-else>
                  <input
                    v-if="elContains([0, 3], user.is_keesing)"
                    type="file"
                    ref="image_back"
                    @change="onFileChangeImage"
                    accept="image/x-png, image/jpeg"
                    class="placeholder"
                    id="image_back"
                  />
                  <svg-icon icon="id_card_back" />
                  <div v-if="elContains([0, 3], user.is_keesing) && (!this.$refs || !this.$refs.image_back || !this.$refs.image_back.files[0])" class="text-container">
                    <svg-icon icon="warning" class="missing"/>
                    Foto <b>achterzijde</b> uploaden
                  </div>
                  <div v-if="elContains([1, 2, 9], user.is_keesing) || (this.$refs && this.$refs.image_back && this.$refs.image_back.files[0])" class="text-container">
                    <svg-icon icon="checkmark_circle" class="check" />
                    Foto <b>achterzijde</b> geüpload
                  </div>
                </label>
              </div>
              <p v-if="elContains([0, 3], user.is_keesing)" class="mb-0">
                <a
                  class="text-derect"
                  role="button"
                  aria-expanded="false"
                  aria-controls="collapseExample"
                  @click="openModal"
                >
                  <span class="extra-info"><svg-icon icon="information" />Instructie voor het aanleveren van het ID, paspoort of verbijfsdocument</span>
                </a>
              </p>
              <IdInstructionModal
                v-if="showIdModal"
                @close="closeModal"
                @confirm="confirmModal"
                :documentType="form.id_type"
              />

              <!-- VOG -->
              <div class="row justify-content-around">
                <div :class="{ 'col-12': branch == 1, 'col-sm-6 sd-align': branch == 2 }">
                  <h2 class="pt-3 mb-4 sd-title">Upload je VOG Certificaat</h2>
                  <div class="document vog mb-4" :class="[vog_accepted ? 'vog-accepted' : '']">
                    <label class="icon svg position-relative 3">
                      <input
                        v-if="!vog_accepted"
                        type="file"
                        ref="vog_image"
                        @change="onFileChangeVOGImage"
                        class="placeholder"
                      />
                      <svg-icon icon="draft" :class="[vog_accepted ? 'ok' : 'empty']" />
                      <div v-if="vog_accepted || this.file_uploaded.vog" class="check"><svg-icon icon="checkmark_circle" /></div>
                      <div v-else class="missing"><svg-icon icon="warning" /></div>
                      <span v-if="vog_accepted || this.file_uploaded.vog" class="text-container"><b>VOG</b> geüpload</span>
                      <span v-else class="text-container">Upload <b>VOG</b></span>
                    </label>
                  </div>
                  <!-- VOG button -->
                  <div v-if="!vog_accepted" class="">
                    <div v-if="!user.vog_request" class="text-center text-14 mb-4">
                      <button
                        @click.prevent="requestVOG"
                        type="button"
                        class="btn btn-outline-warning btn-block"
                        v-ripple="'rgba(145, 139, 136, 0.1)'"
                      >
                        Vraag <strong>VOG Certificaat</strong> aan
                      </button>
                    </div>
                  </div>
                  <p v-if="!vog_accepted" class="mb-2">
                    <a
                      class="text-derect"
                      data-toggle="collapse"
                      href="#collapseExample"
                      role="button"
                      aria-expanded="false"
                      aria-controls="collapseExample"
                    >
                      <span class="extra-info">
                        <svg-icon icon="information" /> Heb je deze nog niet?
                      </span>
                    </a>
                  </p>
                  <div v-if="!vog_accepted" class="">
                    <div class="collapse" id="collapseExample">
                      <div class="alert alert-info mb-1" role="alert">
                        <div class="small text-left">
                          Om via Derect te werken heb je een geldige Verklaring Omtrent Gedrag (VOG) nodig. Wanneer je al een VOG hebt die minder dan 6 maanden oud is, hoef je geen nieuwe aan te vragen. De aanvraagkosten van een nieuwe VOG krijg je vergoed wanneer je 2 of meer dagen als uitzendkracht via Derect aan de slag gaat.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- PRK -->
                <div class="col-sm-6" v-if="branch == 2">
                  <h2 class="sd-title medium pt-3 mb-4">Upload bewijs inschrijving PRK</h2>
                  <div class="document vog mb-4">
                    <label class="icon svg position-relative 3" :class="[prk_accepted ? 'uploaded' : 'uploadable']">
                      <input
                        v-if="!prk_accepted"
                        type="file"
                        ref="prk_image"
                        @change="onFileChangePRKImage"
                        class="placeholder"
                      />
                      <svg-icon icon="draft" :class="[prk_accepted ? 'ok' : 'empty']" />
                      <div v-if="prk_accepted || this.file_uploaded.prk" class="check"><svg-icon icon="checkmark_circle" /></div>
                      <div v-else class="missing"><svg-icon icon="warning" /></div>
                      <span v-if="prk_accepted || this.file_uploaded.prk" class="text-container"><b>PRK</b> geüpload</span>
                      <span v-else class="text-container">Upload <b>PRK</b></span>
                    </label>
                  </div>
                  <p v-if="!prk_accepted" class="small mb-0">
                    <a
                      class="text-derect"
                      data-toggle="collapse"
                      href="#collapsePrk"
                      role="button"
                      aria-expanded="false"
                      aria-controls="collapsePrk"
                    >
                      Waar moet dit bewijs aan voldoen?
                      <span class="question-mark">?</span>
                    </a>
                  </p>
                  <div v-if="!prk_accepted" class="pt-3">
                    <div class="collapse" id="collapsePrk">
                      <div class="alert alert-info mb-1" role="alert">
                        <div class="small text-left">
                          Log in bij het Personenregister Kinderopvang en maak een screenshot van de pagina waarop jouw VOG-kenmerk staat incl. continu screening.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- SAVE BUTTON -->
              <button
                type="button"
                class="btn btn-warning btn-block mt-4"
                @click="triggerSubmit"
              >
                {{ action == "next" ? "Volgende" : "Opslaan" }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="step next-btn" hidden>
      <div class="px-4 mx-2">
        <button
          type="button"
          class="btn btn-warning btn-block"
          @click="triggerSubmit"
        >
          {{ action == "next" ? "Volgende" : "Opslaan" }}
        </button>
      </div>
    </div>

    <div id="keesing-overlay" v-if="keesingOverlay.active">
      <div class="bg-image"></div>
      <div class="keesing-content text-center px-4">
        <template v-if="keesingOverlay.phase === 'processing'">
          <div class="fulfilling-bouncing-circle-spinner mx-auto mb-4">
            <div class="circle"></div>
            <div class="orbit"></div>
          </div>
          <h2 class="sd-title mini text-white mb-2">
            {{ keesingOverlay.manualReview
              ? "Je identificatiebewijs wordt gecontroleerd"
              : "We controleren je identificatiebewijs…" }}
          </h2>
          <p v-if="keesingOverlay.manualReview" class="text-white mb-0">
            Je identificatiebewijs wordt even nagekeken. Een momentje geduld!
          </p>
          <p v-else class="text-white mb-0">
            {{ keesingProcessingMessage }}
          </p>
        </template>

        <template v-else-if="keesingOverlay.phase === 'declined'">
          <div class="keesing-icon missing mb-3"><svg-icon icon="warning" /></div>
          <h2 class="sd-title mini text-white mb-2">Controle niet gelukt</h2>
          <p class="text-white mb-4">
              Je identificatiebewijs wordt niet goed gelezen. Wil je het nog een keer proberen met een duidelijke foto van de voor- en achterkant? Het hele document moet duidelijk zichtbaar zijn om de controle te laten lukken.
          </p>
          <button type="button" class="btn btn-warning btn-block" @click="retryKeesing">
            Opnieuw uploaden
          </button>
        </template>

        <template v-else-if="keesingOverlay.phase === 'review'">
          <div class="keesing-icon mb-3"><svg-icon icon="information" /></div>
          <h2 class="sd-title mini text-white mb-2">
            We kijken er even wat beter naar
          </h2>
          <p class="text-white mb-4">
            We moeten je identificatiebewijs wat uitgebreider bekijken. Dit kan
            even duren, maar zodra we klaar zijn laten we het je zo snel
            mogelijk weten!
          </p>
          <button type="button" class="btn btn-warning btn-block" @click="closeKeesingReview">
            Sluiten
          </button>
        </template>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import IdInstructionModal from "@/components/IdInstructionModal";

export default {
  data: function() {
    return {
      branch: null,
      user: "",
      form: {
        id_type: "P",
        id_image: "",
        id_image_back: "",
        vog_image: "",
        prk_image: "",
        avatar: ""
      },
      vog_accepted: false,
      vog_expired: false,
      prk_accepted: false,
      preview_avatar: "",
      preview_id_image: "",
      preview_id_image_back: "",
      preview_vog_image: "",
      preview_prk_image: "",
      passport_upload: true,
      id_upload: false,
      prevRoute: null,
      showIdModal: false,
      modalConfirmed: false,
      file_uploaded: {
        'vog' : false,
        'prk' : false,
      },
      notifContainer: [],
      keesingOverlay: {
        active: false,
        phase: "processing",
        waitStage: 0,
        manualReview: false
      },
      keesingTimer: null
    };
  },
  components: {
    IdInstructionModal
  },
  props: ["action"],
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      this.branch = localStorage.getItem("branch");
      this.user = JSON.parse(localStorage.getItem("user"));
      let notification = {};

      if (this.user.vog_status === "expired")
        this.vog_expired = true;
      else if (this.user.vog_status === "approved"  || this.user.vog_status === "exported" || this.user.vog_status === "expired" || this.user.vog_status === "pending")
        this.vog_accepted = true;

      if (this.user.prk_status === "approved" || this.user.prk_status === "pending")
        this.prk_accepted = true;

      // Check VOG & PRK Status
      if(this.branch == 2)
      {
        // VOG & PRK
        if(this.user.prk_status === "no_file" && this.user.vog_status === "no_file")
        {
          notification = {
            type: "danger",
            message: "Er is nog geen PRK of VOG geüpload!",
            noTryAgain: true
          };
          this.notifContainer.push(notification);
        }
        else if(this.user.prk_status === "no_file" || this.user.vog_status === "no_file")
        {
          if(this.user.prk_status === "no_file")
          {
            notification = {
              type: "danger",
              message: "Er is nog geen PRK geüpload!",
              noTryAgain: true
            };
            this.notifContainer.push(notification);
          }
          if(this.user.vog_status === "no_file")
          {
            notification = {
              type: "danger",
              message: "Er is nog geen VOG geüpload!",
              noTryAgain: true
            };
            this.notifContainer.push(notification);
          }
        }

        if(this.user.prk_status === "pending" && this.user.vog_status === "pending")
        {
          notification = {
            type: "warning",
            message: "Jouw VOG en PRK worden nu bekeken, we laten zo snel mogelijk weten of het is goedgekeurd!"
          };
          this.notifContainer.push(notification);
        }
        else if(this.user.prk_status === "pending" || this.user.vog_status === "pending")
        {
          if(this.user.prk_status === "pending")
          {
            notification = {
              type: "warning",
              message: "Jouw PRK wordt nu bekeken, we laten zo snel mogelijk weten of het is goedgekeurd!"
            };
            this.notifContainer.push(notification);
          }
          if(this.user.vog_status === "pending")
          {
            notification = {
              type: "warning",
              message: "Jouw VOG wordt nu bekeken, we laten zo snel mogelijk weten of het is goedgekeurd!"
            };
            this.notifContainer.push(notification);
          }
        }

        if(this.user.prk_status === "expired" && this.user.vog_status === "expired")
        {
          notification = {
            type: "danger",
            message: "Jouw VOG en PRK zijn verlopen",
            noTryAgain: true
          };
          this.notifContainer.push(notification);
        }
        else if(this.user.prk_status === "expired" || this.user.vog_status === "expired")
        {
          if(this.user.prk_status === "expired")
          {
            notification = {
              type: "danger",
              message: "Jouw PRK is verlopen!",
              noTryAgain: true
            };
            this.notifContainer.push(notification);
          }
          if(this.user.vog_status === "expired")
          {
            notification = {
              type: "danger",
              message: "Jouw VOG is verlopen!",
              noTryAgain: true
            };
            this.notifContainer.push(notification);
          }
        }

        if(this.user.prk_status === "rejected" && this.user.vog_status === "rejected")
        {
          notification = {
            type: "danger",
            message: "Jouw VOG en PRK zijn afgewezen.",
            noTryAgain: true
          };
          this.notifContainer.push(notification);
        }
        else if(this.user.prk_status === "rejected" || this.user.vog_status === "rejected")
        {
          if(this.user.prk_status === "rejected")
          {
            notification = {
              type: "danger",
              message: "Jouw PRK is afgewezen.",
              noTryAgain: true
            };
            this.notifContainer.push(notification);
          }
          if(this.user.vog_status === "rejected")
          {
            notification = {
              type: "danger",
              message: "Jouw VOG is afgewezen.",
              noTryAgain: true
            };
            this.notifContainer.push(notification);
          }
        }

        if(this.user.prk_status === "approved" && this.user.vog_status === "approved")
        {
          notification = {
            type: "success",
            message: "Je bewijs van inschrijving PRK is bij ons binnen! en je VOG Certificaat is bij ons binnen!",
            noTryAgain: true
          };
          this.notifContainer.push(notification);
        }
        else if(this.user.prk_status === "approved" || this.user.vog_status === "approved")
        {
          if(this.user.prk_status === "approved")
          {
            notification = {
              type: "success",
              message: "Je bewijs van inschrijving PRK is bij ons binnen!",
              noTryAgain: true
            };
            this.notifContainer.push(notification);
          }
          if(this.user.vog_status === "approved")
          {
            notification = {
              type: "danger",
              message: "Je VOG Certificaat is bij ons binnen!",
              noTryAgain: true
            };
            this.notifContainer.push(notification);
          }
        }
      }
      else
      {
        // VOG
        if(this.user.vog_status === "no_file" && this.user.sub_branch !== '2')
        {
          notification = {
            type: "danger",
            message: "Er is nog geen VOG geüpload!",
            noTryAgain: true
          };
          this.notifContainer.push(notification);
        }

        if(this.user.vog_status === "approved")
        {
          notification = {
            type: "success",
            message: "Jouw bestanden zijn geaccepteerd"
          };
          this.notifContainer.push(notification);
        }

        if(this.user.vog_status === "pending")
        {
          notification = {
            type: "warning",
            message: "Jouw VOG wordt nu bekeken, we laten zo snel mogelijk weten of het is goedgekeurd!"
          };
          this.notifContainer.push(notification);
        }

        if(this.user.vog_status === "rejected")
        {
          notification = {
            type: "danger",
            message: "Jouw VOG is afgewezen.",
            noTryAgain: true
          };
          this.notifContainer.push(notification);
        }

        if(this.user.vog_status === "expired")
        {
          notification = {
            type: "danger",
            message: "Jouw VOG is verlopen.",
            noTryAgain: true
          };
          this.notifContainer.push(notification);
        }
      }

      if(this.user.is_keesing == 0 && this.user.sub_branch !== '2')
      {
        if(this.user.id_image != '' && this.user.id_image != null)
        {
          notification = {
            type: "warning",
            message: "Momenteel wordt jouw ID, paspoort of verblijfsdocument nog gecontroleerd. Dit zal niet lang duren, probeer het dus later nog eens.",
            noTryAgain: true
          };
          this.notifContainer.push(notification);
        }
        else
        {
          notification = {
            type: "danger",
            message: "Er is nog geen Paspoort, ID of verblijfsdocument geüpload.",
            noTryAgain: true
          };
          this.notifContainer.push(notification);
        }
      }

      if (this.user.sub_branch === '2') {
        notification = {
          type: "warning",
          message: "Om te solliciteren op vacatures in het voortgezet onderwijs is het niet nodig hier een identiteitsbewijs en een VOG te uploaden.",
          noTryAgain: true
        };
        this.notifContainer.push(notification);
      }

      if(this.user.is_keesing == 3)
      {
        notification = {
          type: "danger",
          message: "Het controleren van je ID, paspoort of verblijfsdocument is helaas niet gelukt. Probeer het nogmaals of ",
          noTryAgain: true,
          redirect_url: "contact",
          redirect_msg: "neem contact met ons op."
        };
        this.notifContainer.push(notification);
      }

      if(this.user.is_keesing == 1 || this.user.is_keesing == 2 || this.user.is_keesing == 9)
      {
        notification = {
          type: "success",
          message: "Je ID, paspoort of verblijfsdocument is bij ons binnen!",
          noTryAgain: true
        };
        this.notifContainer.push(notification);
      }

      if(this.user.vog_request && !this.vog_accepted) {
        notification = {
          type: "warning",
          message: "De aanvraag voor je VOG is gedaan. Je ontvangt een mail van Justis met verdere instructies!",
          noTryAgain: true
        };
        this.notifContainer.push(notification);
      }

      this.$store.dispatch("notification/replace", {}, {root: true});

      this.notifContainer.forEach((notif) => {
        this.$store.dispatch("notification/add", notif, {root: true});
      });
    },
    openModal() {
      if(!this.elContains([1, 2, 9], this.user.is_keesing))
        this.showIdModal = true;
    },
    closeModal() {
      this.showIdModal = false;
    },
    confirmModal() {
      this.closeModal();
      this.modalConfirmed = true;
    },
    onFileChangeAvatar() {
      this.form.avatar = this.$refs.avatar.files[0];
      this.preview_avatar = URL.createObjectURL(this.form.avatar);
      localStorage.setItem("form-pending", JSON.stringify(true));
    },
    onFileChangeImage() {
      var notification = false;
      var documentType = '';
      if (this.form.id_type == 'P')
      {
        documentType = 'paspoort';
      }
      else if (this.form.id_type == 'V')
      {
        documentType = 'verblijfsdocument';
      }
      else {
        documentType = 'ID';
      }
      /*
      if (this.form.id_type == 'P') {
        this.form.id_image = this.$refs.image.files[0];
        this.preview_id_image = URL.createObjectURL(this.form.id_image);
        localStorage.setItem("form-pending", JSON.stringify(true));
        notification = {
          type: "success",
          message: "Je paspoort is klaar om geüpload te worden. Klik op Opslaan. "
        };
        this.$store.dispatch("notification/replace", notification, {
          root: true
        });
      } else {
      */
      if(this.$refs.image_front.files[0] && this.$refs.image_back.files[0]) {
        this.form.id_image = this.$refs.image_front.files[0];
        this.form.id_image_back = this.$refs.image_back.files[0];
        this.preview_id_image = URL.createObjectURL(this.form.id_image);
        this.preview_id_image_back = URL.createObjectURL(this.form.id_image_back);
        localStorage.setItem("form-pending", JSON.stringify(true));
        notification = {
          type: "success",
          message: "Je " + documentType + " is klaar om geüpload te worden. Klik op Opslaan. "
        };

      } else {
        if (!this.$refs.image_front.files[0]) {
          notification = {
            type: "warning",
            message: "Upload een foto van je " + documentType + " voorzijde!"
          };
        } else if (!this.$refs.image_back.files[0]) {
          notification = {
            type: "warning",
            message: "Upload een foto van je " + documentType + " achterzijde!"
          };
        }
      }

      if(notification) {
        this.$store.dispatch("notification/replace", notification, {
            root: true
          });
      }
      this.notifContainer.forEach((notif) => {
        this.$store.dispatch("notification/add", notif, {root: true});
      });
      // }
    },
    onFileChangeVOGImage() {
      this.form.vog_image = this.$refs.vog_image.files[0];
      if(this.form.vog_image != '' && this.form.vog_image != null)
      {
        this.file_uploaded.vog = true;
        this.preview_vog_image = URL.createObjectURL(this.form.vog_image);
        localStorage.setItem("form-pending", JSON.stringify(true));
        this.setFileNotification();
      }
      else
      {
        this.file_uploaded.vog = false;
        this.$store.dispatch("notification/replace", {}, {
          root: true
        });

        this.notifContainer.forEach((notif) => {
          this.$store.dispatch("notification/add", notif, {root: true});
        });
      }
    },
    onFileChangePRKImage() {
      this.form.prk_image = this.$refs.prk_image.files[0];
      if(this.form.prk_image != '' && this.form.prk_image != null)
      {
        this.file_uploaded.prk = true;
        this.preview_prk_image = URL.createObjectURL(this.form.prk_image);
        localStorage.setItem("form-pending", JSON.stringify(true));
        this.setFileNotification();
      }
      else
      {
        this.file_uploaded.prk = false;
        this.$store.dispatch("notification/replace", {}, {
          root: true
        });

        this.notifContainer.forEach((notif) => {
          this.$store.dispatch("notification/add", notif, {root: true});
        });
      }
    },
    setFileNotification() {
      const notification = {
        type: "success",
        message: "Er staat een bestand klaar om geüpload te worden, je kan nu op Opslaan klikken."
      };
      this.$store.dispatch("notification/replace", notification, {
        root: true
      });
    },
    onFormChange() {
      localStorage.setItem("form-pending", JSON.stringify(true));
    },
    triggerSubmit() {
      var elem = this.$refs.submit;
      elem.click();
    },
    async updateUserAvatar() {
      return new Promise(resolve => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/applicant";
        let formData = new FormData();
        for (var obj in this.form) {
          if (obj == "avatar") {
            formData.append(obj, this.form[obj]);
          }
        }
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            // console.log(success);
            localStorage.removeItem("form-pending");
            resolve();
          })
          .catch(() => {
            // console.log(error);
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden.",
                error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
          });
      });
    },
    async updateUserIDImage() {
      return new Promise((resolve, reject) => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/legitimize";
        let formData = new FormData();
        for (var obj in this.form) {
          if (obj == "id_image" && this.preview_id_image) {
            formData.append(obj, this.form[obj]);
          }
          if (obj == "id_image_back" && this.preview_id_image_back) {
            formData.append(obj, this.form[obj]);
          }
          if (obj == "vog_image" && this.preview_vog_image) {
            formData.append(obj, this.form[obj]);
          }
          if (obj == "prk_image" && this.preview_prk_image) {
            formData.append(obj, this.form[obj]);
          }
          if (obj == "id_type") {
            formData.append(obj, this.form[obj]);
          }
        }
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            // console.log(success);
            localStorage.removeItem("form-pending");
            resolve();
          })
          .catch(() => {
            // console.log(error);
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden.",
                error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
            reject();
          });
      });
    },
    async requestVOG() {
      await this.sendRequest();

      // if request success
      // update info
      await this.updateLocalUser();
      this.user = JSON.parse(localStorage.getItem("user"));

      // show screen
      this.$store.state.loading = false;
    },
    async sendRequest() {
      return new Promise(resolve => {
        this.$store.state.loading = true;
        window.scrollTo(0, 0);
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        this.$http
          .get(this.$apiURI + "/vogrequest", {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            // console.log(success);
            resolve();
          })
          .catch(() => {
            // console.log(error);
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden.",
                error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });

            this.$store.state.loading = false;
          });
      });
    },
    async redirectBack() {
      return new Promise(() => {
        setTimeout(() => {
          if (this.prevRoute.name) {
            this.$router.replace({
              name: this.prevRoute.name,
                  params: this.prevRoute.params
            }).catch(() => {});
          } else {
            this.$router.replace({
                  name: 'applicant-dashboard',
            }).catch(() => {});
            }
        }, 800);
      });
    },
    async onSubmit() {
      // console.log("async onSubmit()");
      window.scrollTo(0, 0);

      var id_image_proceed = false;
      if (this.preview_id_image && this.preview_id_image_back) {
        id_image_proceed = true;
      }

      if (id_image_proceed) {
        this.keesingOverlay.active = true;
        this.keesingOverlay.phase = "processing";
        this.keesingOverlay.waitStage = 0;
        this.keesingOverlay.manualReview = false;
        this.$store.state.loading = false;
      } else {
        this.$store.state.loading = true;
      }

      if (this.preview_avatar) {
        await this.updateUserAvatar();
      }

      if(id_image_proceed || this.preview_vog_image || this.preview_prk_image)
      {
        try {
          await this.updateUserIDImage();
        } catch (e) {
          this.keesingOverlay.active = false;
          this.$store.state.loading = false;
          return false;
        }
      }
      else
      {
        const notification = {
          type: "danger",
          message: "Geen juist bestand geupload. Controleer of het bestand bestaat of juist is."
        };
        this.$store.dispatch("notification/replace", notification, {
          root: true
        });
        this.$store.state.loading = false;
        return false;
      }

      if (id_image_proceed) {
        const outcome = await this.pollKeesingStatus();

        if (outcome === "declined" || outcome === "timeout") {
          await this.updateLocalUser();
          this.user = JSON.parse(localStorage.getItem("user"));
          this.keesingOverlay.phase = outcome === "declined" ? "declined" : "review";
          this.$store.state.loading = false;
          return;
        }

        this.keesingOverlay.active = false;
      }

      await this.updateLocalUser();
      this.user = JSON.parse(localStorage.getItem("user"));
  
      if (this.action == "next") {
        this.$router.replace({
          name: "applicant-step_2",
          params: { action: "next" }
        });
      } else {
        await this.redirectBack();
      }

      this.$store.state.loading = false;
    },
    async pollKeesingStatus() {
      return new Promise(resolve => {
        const user_token = JSON.parse(localStorage.getItem("user-token"));
        const url = this.$apiURI + "/keesingstatus";
        const startedAt = Date.now();
        const MAX_DURATION = 120 * 1000;
        const INTERVAL = 3000;

        this.keesingOverlay.active = true;
        this.keesingOverlay.phase = "processing";
        this.keesingOverlay.waitStage = 0;
        this.keesingOverlay.manualReview = false;
        this.$store.state.loading = false;

        let stopped = false;
        const finish = outcome => {
          if (stopped) return;
          stopped = true;
          if (this.keesingTimer) {
            clearInterval(this.keesingTimer);
            this.keesingTimer = null;
          }
          resolve(outcome);
        };

        const tick = () => {
          const elapsed = Date.now() - startedAt;
          this.keesingOverlay.waitStage = Math.min(7, Math.floor(elapsed / 15000));
          if (elapsed >= MAX_DURATION) {
            finish("timeout");
            return;
          }
          this.$http
            .get(url, {
              headers: {
                Authorization: "Bearer " + user_token,
                Accept: "application/json"
              }
            })
            .then(resp => {
              const data = resp.data || {};
              const outcome = this.classifyKeesingStatus(data);
              if (outcome === "manual_review") {
                this.keesingOverlay.manualReview = true;
                return;
              }
              if (outcome !== "pending") {
                finish(outcome);
              }
            })
            .catch(() => {});
        };

        tick();
        this.keesingTimer = setInterval(tick, INTERVAL);
      });
    },
    classifyKeesingStatus(data) {
      data = data || {};
      const stage = (data.stage || "").toString().toLowerCase();
      const result = (data.result || "").toString().toLowerCase();

      if (data.complete === true || stage === "complete") {
        return result === "passed" ? "approved" : "declined";
      }

      if (stage === "error") {
        return "declined";
      }

      if (stage === "manual_review") {
        return "manual_review";
      }

      return "pending";
    },
    retryKeesing() {
      this.keesingOverlay.active = false;
      this.keesingOverlay.phase = "processing";
      this.keesingOverlay.waitStage = 0;
      this.keesingOverlay.manualReview = false;
      this.preview_id_image = "";
      this.preview_id_image_back = "";
      this.form.id_image = "";
      this.form.id_image_back = "";
      this.modalConfirmed = false;
      this.notifContainer = [];
      this.fetchData();
      window.scrollTo(0, 0);
    },
    closeKeesingReview() {
      this.keesingOverlay.active = false;
      this.$router.replace({ name: "applicant-dashboard" }).catch(() => {});
    },
    elContains(str, target) {
      return str.includes(target);
    },
    toggleUpload() {
      this.passport_upload = !this.passport_upload;
      this.id_upload = !this.id_upload;
      this.preview_id_image = '';
      this.preview_id_image_back = '';
      this.form.id_image = '';
      this.form.id_image_back = '';
      this.$store.dispatch("notification/replace", {}, {
        root: true
      });

      this.notifContainer.forEach((notif) => {
        this.$store.dispatch("notification/add", notif, {root: true});
      });
      console.log(this.notifContainer);
    }
  },
  computed: {
    keesingProcessingMessage() {
      const messages = [
        "Een momentje, dit duurt meestal maar heel even!",
        "We zijn ermee bezig, nog heel even geduld.",
        "Nog even, we controleren je gegevens zorgvuldig.",
        "We zijn er bijna, nog heel even geduld!",
        "Het duurt iets langer dan normaal, maar we zijn er nog mee bezig.",
        "Nog een klein momentje, we zijn bijna klaar.",
        "We ronden de controle bijna af, nog heel even!",
        "Nog heel even geduld, we zijn de laatste check aan het doen…"
      ];
      return messages[this.keesingOverlay.waitStage] || messages[messages.length - 1];
    }
  },
  beforeDestroy() {
    if (this.keesingTimer) {
      clearInterval(this.keesingTimer);
      this.keesingTimer = null;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  beforeRouteLeave(to, from, next) {
    this.savePending(to, from, next);
  }
};
</script>

<style scoped>
#keesing-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
}

#keesing-overlay .bg-image {
  background: #484848;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.85;
}

#keesing-overlay .keesing-content {
  position: relative;
  z-index: 1;
  max-width: 340px;
  width: 100%;
}

#keesing-overlay .keesing-content .text-white {
  color: #ffffff;
}

#keesing-overlay .keesing-icon {
  font-size: 56px;
  line-height: 1;
  color: #FFCD00;
}

#keesing-overlay .keesing-icon.missing ::v-deep svg,
#keesing-overlay .keesing-icon ::v-deep svg {
  width: 56px;
  height: 56px;
}

.fulfilling-bouncing-circle-spinner,
.fulfilling-bouncing-circle-spinner * {
  box-sizing: border-box;
}

.fulfilling-bouncing-circle-spinner {
  height: 96px;
  width: 96px;
  position: relative;
  animation: fulfilling-bouncing-circle-spinner-animation infinite 4000ms ease;
}

.fulfilling-bouncing-circle-spinner .orbit {
  height: 96px;
  width: 96px;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 50%;
  animation: fulfilling-bouncing-circle-spinner-orbit-animation infinite 4000ms ease;
}

.fulfilling-bouncing-circle-spinner .circle {
  height: 96px;
  width: 96px;
  color: #ffcd00;
  display: block;
  border-radius: 50%;
  position: relative;
  border: 5px solid #ffcd00;
  animation: fulfilling-bouncing-circle-spinner-circle-animation infinite 4000ms ease;
  transform: rotate(0deg) scale(1);
}

@keyframes fulfilling-bouncing-circle-spinner-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes fulfilling-bouncing-circle-spinner-circle-animation {
  0% {
    border-color: transparent;
    border-top-color: inherit;
  }
  16.7% {
    border-color: transparent;
    border-top-color: initial;
    border-right-color: initial;
  }
  33.4% {
    border-color: transparent;
    border-top-color: inherit;
    border-right-color: inherit;
    border-bottom-color: inherit;
  }
  50% {
    border-color: inherit;
  }
  62.5% {
    border-color: inherit;
  }
  75% {
    border-color: inherit;
    opacity: 1;
  }
  87.5% {
    border-color: inherit;
  }
  100% {
    border-color: transparent;
    border-top-color: inherit;
  }
}

/* Start new SD style */
.document.vog a,
.document.vog label,
.document.photo_id a,
.document.photo_id label {
  position: relative;
  display: flex;
  align-items: center;
  border: 2px solid #FFF0B2;
  border-radius: 10px;
  padding: 10px 30px;
  cursor: pointer;
  margin-bottom: 0;
}

.document.id-approved.photo_id a,
.document.vog-accepted.vog label {
  cursor: default;
}

.row .sd-align {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

::v-deep .document .svg-container {
  display: flex;
  position: absolute;
}

.document .text-container {
  width: 100%;
  text-align: center;
}

input[type="file"].placeholder {
  z-index: -1;
}
/* End new SD style */

.btn-outline-warning {
  font-family: "Real Head Pro";
  font-weight: 200;
  color: #64513D;
  border: 2px solid #FFF0B2;
}
::v-deep .alert {
  margin-bottom: 5px;
}
.document .icon .image_background {
  border-radius: 100%;
  border: 5px solid #64513D;
}

.document .icon.svg > i.material-icons {
  position: absolute;
  z-index: 1;
  color: #FFCD00;
  font-size: 24px;
  background: white;
  overflow: hidden;
  border-radius: 100%;
  top: 14px;
  right: 1px;
}

.pt-4.px-4.mx-2.pb-4.text-center {
  padding-right: 10px !important;
  padding-left: 10px !important;
}
.heading-20-500 {
  font-size: 18px;
}
.document .left span.photo-comment {
  margin-right: 75px;
}

.document .icon.vog {
  border: 6px solid #64513D;
}
.document .icon.vog i {
  color: #FFCD00;
  font-size: 50px;
  margin-top: 24px;
}
span.question-mark {
  width: 28px;
  height: 28px;
  background: #FFCD00;
  color: #FFF;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  font: 16px/28px "Real Head Pro";
  font-weight: normal;
  margin-left: 10px;
}
.document ~ p.success {
  background: #bafbe6;
  border-radius: 10px;
  padding: 10px 20px;
  font-family: "Real Head Pro";
  font-weight: normal;
}
.document.mb-4:not(.vog) + p.small {
  padding-bottom: 20px;
}

::v-deep .document .text-container .check,
::v-deep .document .text-container .missing {
  position: absolute;
  top: 5px;
  left: 47px;
}

::v-deep .document .icon .check,
::v-deep .document .icon .missing {
  position: absolute;
  top: 5px;
  left: 40px;
}

::v-deep .document .text-container .check svg,
::v-deep .document .text-container .missing svg,
::v-deep .document .icon .check svg,
::v-deep .document .icon .missing svg {
  width: 15px;
  height: 15px;
  background-color: #FFF;
}

::v-deep .document .text-container .check svg,
::v-deep .document .icon .check svg {
  color: #44B24C;
}

::v-deep .document .text-container .missing svg,
::v-deep .document .icon .missing svg {
  color: #FF5A5A;
}

</style>
